/**
 * Pure branch-name logic. No SDK, no DOM — so it unit-tests in plain node.
 *
 * BIC convention (derived from origin/*):
 *   7152-clu-import-scaling-fix     work item + kebab description
 *   7119m-optimum-quoter-overlap    trailing "m" = branched from main, not develop
 */
export const MAX_LENGTH = 60;
const COMBINING_MARKS = /[̀-ͯ]/g;
export function kebab(input) {
    return input
        .normalize("NFKD")
        .replace(COMBINING_MARKS, "") // Šumak -> Sumak
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
export function buildBranchName(input) {
    const id = input.workItem.trim();
    const suffix = input.fromMain ? "m" : "";
    const desc = kebab(input.description);
    if (!id)
        return desc;
    return desc ? `${id}${suffix}-${desc}` : `${id}${suffix}`;
}
/** Returns an error string, or null when the name is valid. */
export function validate(name) {
    if (!name)
        return "Name is empty";
    if (name.length > MAX_LENGTH)
        return `Too long (${name.length}/${MAX_LENGTH})`;
    if (!/^\d+m?-[a-z0-9-]+$/.test(name)) {
        return "Must be {workItemId}[m]-{kebab-description}";
    }
    // git check-ref-format rules the pattern above doesn't already exclude
    if (name.includes("--"))
        return "No double hyphens";
    if (name.endsWith(".lock"))
        return "Cannot end with .lock";
    return null;
}
